import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FrTrainingVideosComponent} from './fr-training-videos.component';
import {DialogModule} from 'primeng/dialog';
import {SidebarModule} from 'primeng/sidebar';
import {ButtonModule} from 'primeng/button';


@NgModule({
    declarations: [FrTrainingVideosComponent],
    imports: [
        CommonModule,
        DialogModule,
        SidebarModule,
        ButtonModule,

    ]
})
export class FrTrainingVideosModule {
}
